import { type } from '@/utils/type'

//////////////////////////////////////////////////////////////////
// SEJOUR
/////////////////////////////////////////////////////////////////
export const ADM_SEJOUR_SUCCESS =  type('ADM_SEJOUR_SUCCESS')
export const ADM_SEJOUR_ERROR =  type('ADM_SEJOUR_ERROR')

export const ADM_SEJOUR_DETAIL_SUCCESS =  type('ADM_SEJOUR_DETAIL_SUCCESS')
export const ADM_SEJOUR_DETAIL_ERROR =  type('ADM_SEJOUR_DETAIL_ERROR')

export const ADM_SEJOUR_SAVE_SUCCESS =  type('ADM_SEJOUR_SAVE_SUCCESS')
export const ADM_SEJOUR_SAVE_ERROR =  type('ADM_SEJOUR_SAVE_ERROR')

export const ADM_SEJOUR_DELETE_SUCCESS =  type('ADM_SEJOUR_DELETE_SUCCESS')
export const ADM_SEJOUR_DELETE_ERROR =  type('ADM_SEJOUR_DELETE_ERROR')

export const ADM_SEJOUR_UPDATE_LAST_QUERY_DATE =  type('ADM_SEJOUR_UPDATE_LAST_QUERY_DATE')


//////////////////////////////////////////////////////////////////
// USER
/////////////////////////////////////////////////////////////////
export const ADM_USER_SUCCESS =  type('ADM_USER_SUCCESS')
export const ADM_USER_ERROR =  type('ADM_USER_ERROR')

export const ADM_USER_DETAIL_SUCCESS =  type('ADM_USER_DETAIL_SUCCESS')
export const ADM_USER_DETAIL_ERROR =  type('ADM_USER_DETAIL_ERROR')

export const ADM_USER_SAVE_SUCCESS =  type('ADM_USER_SAVE_SUCCESS')
export const ADM_USER_SAVE_ERROR =  type('ADM_USER_SAVE_ERROR')

export const ADM_USER_DELETE_SUCCESS =  type('ADM_USER_DELETE_SUCCESS')
export const ADM_USER_DELETE_ERROR =  type('ADM_USER_DELETE_ERROR')


//////////////////////////////////////////////////////////////////
// COMMANDE
/////////////////////////////////////////////////////////////////
export const ADM_COMMANDE_SUCCESS =  type('ADM_COMMANDE_SUCCESS')
export const ADM_COMMANDE_ERROR =  type('ADM_COMMANDE_ERROR')

export const ADM_COMMANDE_DETAIL_SUCCESS =  type('ADM_COMMANDE_DETAIL_SUCCESS')
export const ADM_COMMANDE_DETAIL_ERROR =  type('ADM_COMMANDE_DETAIL_ERROR')

export const ADM_COMMANDE_SAVE_SUCCESS =  type('ADM_COMMANDE_SAVE_SUCCESS')
export const ADM_COMMANDE_SAVE_ERROR =  type('ADM_COMMANDE_SAVE_ERROR')

export const ADM_COMMANDE_DELETE_SUCCESS =  type('ADM_COMMANDE_DELETE_SUCCESS')
export const ADM_COMMANDE_DELETE_ERROR =  type('ADM_COMMANDE_DELETE_ERROR')

export const ADM_COMMANDE_UPDATE_LAST_QUERY_DATE =  type('ADM_COMMANDE_UPDATE_LAST_QUERY_DATE')

//////////////////////////////////////////////////////////////////
// MAIL_TEMPLATE
/////////////////////////////////////////////////////////////////
export const ADM_MAIL_TEMPLATE_SUCCESS =  type('ADM_MAIL_TEMPLATE_SUCCESS')
export const ADM_MAIL_TEMPLATE_ERROR =  type('ADM_MAIL_TEMPLATE_ERROR')

export const ADM_MAIL_TEMPLATE_DETAIL_SUCCESS =  type('ADM_MAIL_TEMPLATE_DETAIL_SUCCESS')
export const ADM_MAIL_TEMPLATE_DETAIL_ERROR =  type('ADM_MAIL_TEMPLATE_DETAIL_ERROR')

export const ADM_MAIL_TEMPLATE_SAVE_SUCCESS =  type('ADM_MAIL_TEMPLATE_SAVE_SUCCESS')
export const ADM_MAIL_TEMPLATE_SAVE_ERROR =  type('ADM_MAIL_TEMPLATE_SAVE_ERROR')

export const ADM_MAIL_TEMPLATE_DELETE_SUCCESS =  type('ADM_MAIL_TEMPLATE_DELETE_SUCCESS')
export const ADM_MAIL_TEMPLATE_DELETE_ERROR =  type('ADM_MAIL_TEMPLATE_DELETE_ERROR')

//////////////////////////////////////////////////////////////////
// MAIL_SKIN
/////////////////////////////////////////////////////////////////
export const ADM_MAIL_SKIN_SUCCESS =  type('ADM_MAIL_SKIN_SUCCESS')
export const ADM_MAIL_SKIN_ERROR =  type('ADM_MAIL_SKIN_ERROR')

export const ADM_MAIL_SKIN_DETAIL_SUCCESS =  type('ADM_MAIL_SKIN_DETAIL_SUCCESS')
export const ADM_MAIL_SKIN_DETAIL_ERROR =  type('ADM_MAIL_SKIN_DETAIL_ERROR')

export const ADM_MAIL_SKIN_SAVE_SUCCESS =  type('ADM_MAIL_SKIN_SAVE_SUCCESS')
export const ADM_MAIL_SKIN_SAVE_ERROR =  type('ADM_MAIL_SKIN_SAVE_ERROR')

export const ADM_MAIL_SKIN_DELETE_SUCCESS =  type('ADM_MAIL_SKIN_DELETE_SUCCESS')
export const ADM_MAIL_SKIN_DELETE_ERROR =  type('ADM_MAIL_SKIN_DELETE_ERROR')

//////////////////////////////////////////////////////////////////
// PAN_STATUS
/////////////////////////////////////////////////////////////////
export const ADM_PAN_STATUS_SUCCESS =  type('ADM_PAN_STATUS_SUCCESS')
export const ADM_PAN_STATUS_ERROR =  type('ADM_PAN_STATUS_ERROR')

export const ADM_PAN_STATUS_DETAIL_SUCCESS =  type('ADM_PAN_STATUS_DETAIL_SUCCESS')
export const ADM_PAN_STATUS_DETAIL_ERROR =  type('ADM_PAN_STATUS_DETAIL_ERROR')

export const ADM_PAN_STATUS_SAVE_SUCCESS =  type('ADM_PAN_STATUS_SAVE_SUCCESS')
export const ADM_PAN_STATUS_SAVE_ERROR =  type('ADM_PAN_STATUS_SAVE_ERROR')

export const ADM_PAN_STATUS_DELETE_SUCCESS =  type('ADM_PAN_STATUS_DELETE_SUCCESS')
export const ADM_PAN_STATUS_DELETE_ERROR =  type('ADM_PAN_STATUS_DELETE_ERROR')